










import { Component, Mixins, Prop } from 'vue-property-decorator';
import PasswordComponent from '../../../../commoncomponents/passwordcomponent/PasswordComponent.vue';
import commonEntryStore from '@/store/modules/commonEntry';
import StripeModule from '@/store/modules/stripe/module';
import { ScreenText } from '@/lang/ScreenText';
import { PassObj, TypeObj } from '@/Model/model';
import config from '@/config';
import APP_CONST from '@/constants/AppConst';
import APP_UTILITIES from '@/utilities/commonFunctions';
import LoginRightIllustration from '../../commonComponents/loginRightIllustration/LoginRightIllustration.vue';
import AccountSettings from '@/mixins/accountSettings.mixin';
import { getInstance } from '@/auth';
import Spinner from '@/commoncomponents/spinner/Spinner.vue';

@Component({
  components: {
    Spinner,
    'password-component': PasswordComponent,
    'right-illustration': LoginRightIllustration,
  },
})
export default class LoginComponent extends Mixins(AccountSettings) {
  @Prop({ type: String, default: APP_CONST.APP_ROUTES.DASHBOARD.path })
  readonly redirect!: string;
  private authService: any;
  private objScreenText: ScreenText = new ScreenText();
  public typeobj: PassObj = config.loginPassObj;
  public strMessage: string = '';
  public styleClass: string = APP_CONST.UKHIDDEN;
  public emailCheck: boolean | string = '';
  public showNotifyButton: boolean = false;
  public notifyForEmail: string = '';
  public passwordLength = -1;
  public passValidation = {
    oldPassword: -1,
    password: -1,
    confirmPassword: -1,
  };
  public refSource: any = 'web';
  public routeQueryLink: any = '';
  public loginProcessing: boolean = false;

  APP_CONST = APP_CONST;
  stripeModule = StripeModule;

  onClick() {
    this.$gtm &&
      this.$gtm.trackEvent({
        event: null,
        category: 'Login Page',
        action: 'click',
        label: 'Login Page Click Event Activated',
        value: 5000,
        noninteraction: false,
      });
  }

  /* istanbul ignore next */
  async mounted() {
    this.routeQueryLink = this.$route.query.link;
    localStorage.removeItem('goToSitesPage');

    if (this.$route.query.redirect) {
      localStorage.setItem('redirectTo', String(this.$route.query.redirect));
    }

    if (this.$route.query.ref_source == undefined) {
      this.refSource = 'web';
    }
    else {
      this.refSource = this.$route.query.ref_source || '';
    }

    if (this.$route !== undefined && this.$gtm !== undefined) {
      this.$gtm.trackView(this.$route.name, this.$route.path);
    }

    if (
      !window.location.search.includes('code=') ||
      !window.location.search.includes('state=')
    ) {
      if (this.authService.loading) {
        this.authService.$watch('loading', (loading: boolean) => {
          if (!loading) {
            this.authService.loginWithRedirect();
          }
        });
      }
    }

    !this.authService.isAuthenticated && this.authService.loginWithRedirect();

    if (this.authService.loading) {
      this.authService.$watch('loading', (loading: boolean) => {
        if (!loading && this.authService.isAuthenticated) {
          const objLoginData: any = {};
          objLoginData.type = this.typeobj.type;
          this.onSubmit();
          return;
        }
        this.authService.loginWithRedirect();
        APP_UTILITIES.segmentTrackEvent(APP_CONST.SEGMENT_EVENTS.LOGIN.login);
      });
    }
    else if (this.authService.isAuthenticated) {
      let redirectTo = localStorage.getItem('redirectTo');
      localStorage.removeItem('redirectTo');
      redirectTo =
        redirectTo !== 'undefined' || redirectTo !== null
          ? redirectTo
          : this.redirect;
      redirectTo = redirectTo || APP_CONST.APP_ROUTES.DASHBOARD.path;
      const objLoginData: any = {};
      objLoginData.type = this.typeobj.type;
      await this.onSubmit();
      window.history.pushState(
        {},
        '',
        `/${APP_UTILITIES.accountSlug}/#${redirectTo}`
      );
      this.$router.push(redirectTo);
    }
  }

  public getScreenText(key: string): string {
    return this.objScreenText.getScreenText(key);
  }

  /* istanbul ignore next */
  get statusCode() {
    return commonEntryStore.getStatusCode;
  }

  /* istanbul ignore next */
  get email(): string {
    return commonEntryStore.getEmail;
  }

  /* istanbul ignore next */
  set email(email: string) {
    commonEntryStore.setEmail(email);
  }

  /* istanbul ignore next */
  get rememberMe(): boolean {
    return commonEntryStore.getRememberMe;
  }

  /* istanbul ignore next */
  get submitResponse(): object {
    return commonEntryStore.getSubmit;
  }

  get responsePending() {
    return commonEntryStore.isResponsePending;
  }

  public clickRemember(): void {
    const checked = this.rememberMe
      ? false
      : true;
    commonEntryStore.setRememberMe({
      checked: checked,
      type: this.typeobj.type,
    });
  }

  /* istanbul ignore next */
  get mailCheck() {
    return this.emailCheck;
  }

  get logoutRepsonsePending() {
    return commonEntryStore.isLogoutResponsePending;
  }

  public onMailEvent() {
    this.emailCheck = '';
  }

  public emailFocus() {
    commonEntryStore.submitMutate({
      data: { isBxPortal: false, alreadyAdded: false },
    });
    this.emailCheck = true;
  }

  validateEmail(mail: string) {
    // eslint-disable-next-line no-useless-escape
    const re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(mail);
  }

  public async onSubmit() {
    this.loginProcessing = true;

    /* istanbul ignore else */
    if (this.responsePending || this.logoutRepsonsePending) {
      this.loginProcessing = false;
      return;
    }

    const objLoginData: any = {};
    objLoginData.type = this.typeobj.type;

    /* istanbul ignore if */
    if (await commonEntryStore.login(objLoginData as TypeObj)) {
      await StripeModule.createSetupIntent();
    }
    else {
      this.strMessage = this.getScreenText('ERROR_INVALID_EMAIL');
    }

    this.styleClass = APP_CONST.UKVISIBLE;
    this.loginProcessing = false;
  }

  /* istanbul ignore next */
  public beforeMount(): void {
    this.authService = getInstance();
    this.lifeCycleHook();
    APP_UTILITIES.removeSpecificCookie('applicationId');
  }

  public lifeCycleHook() {
    let email = '';
    const tkn = this.$route.query.token;
    /* istanbul ignore else */
    if (tkn != undefined) {
      email = atob(tkn.toString());
    }
    const getUsernameCookie = APP_UTILITIES.getCookie(APP_CONST.USERNAME);
    /* istanbul ignore else */
    if (getUsernameCookie) {
      commonEntryStore.setEmail(getUsernameCookie);
    }
    /* istanbul ignore else */
    if (!this.isNullOrWhitespace(email) || email) {
      commonEntryStore.setEmail(email);
    }
  }

  public isNullOrWhitespace(input: any): boolean {
    if (typeof input === 'undefined' || input == null) {
      return true;
    }
    return input.replace(/\s/g, '').length < 1;
  }
}
